function getBgContainer(moduleId: number) {
    return document.querySelector(`#section_bg_element_${moduleId}`) as HTMLElement;
}

export function positionBg(moduleId: number) {
    let containerEl = getBgContainer(moduleId);
    let rect = containerEl.getBoundingClientRect();
    let vph = window.innerHeight;
    let ratio = rect.height / vph;
    let height = rect.height;
    let top = rect.top;
    let bgElement = Array.from(containerEl.querySelectorAll('.section-bg-element-inner'))
        .find(e => e.parentNode === containerEl) as HTMLElement;

    pos(bgElement, vph, ratio, height, top);
    setHeight(rect, bgElement, vph, ratio);
}

function pos(bgElement: HTMLElement, vph: number, ratio: number, height: number, top: number) {

    let topValue: number;
    if (height < vph) {
         topValue = -(top * ratio);
    } else {
         topValue = -(top / ratio);
    }

    let transformValue = "translateY(" + topValue + "px)";
    bgElement.style.transform = transformValue;
    bgElement.style.webkitTransform = transformValue;
}
function setHeight(rect: ClientRect, bgElement: HTMLElement, vph: number, ratio: number ) {
    bgElement.style.height = (rect.height + (vph * ratio)) + "px";
}

let createListener = (moduleId: number) => (event: UIEvent) => {
    refreshWeb(moduleId);
};

let listeners = new Map<number, EventListener>();

export function refreshWeb(moduleId: number) {
    positionBg(moduleId);
}

export function initWeb(moduleId: number) {
    refreshWeb(moduleId);
    let listener = createListener(moduleId);
    listeners.set(moduleId, listener);

    window.addEventListener('scroll', listener);
    window.addEventListener('resize', listener);
}
export function destroyWeb(moduleId: number) {
    let listener = listeners.get(moduleId);
    if (!listener) {
        throw new Error(`No listener found for moduleId ${moduleId}`);
    }
    window.removeEventListener('scroll', listener);
    window.removeEventListener('resize', listener);
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/web/index.ts
 **/